<div class="wrap">
  <app-section-header-gap
    class="wrap__section wrap__section_header"
  ></app-section-header-gap>
  <lib-image-title
    type="cart"
    class="wrap__section wrap__section_image-title"
    >ご注文内容</lib-image-title
  >
  <!-- <app-section-message
    class="wrap__section wrap__section_section-message"
    message="送料：1冊の場合は385円（全国一律）、2冊以上で770円〜（お届け先により変動）"
  ></app-section-message> -->
  <lib-section-message-date
    class="wrap__section wrap__section_section-message-date"
    (regionChange)="onRegionChange($event)"
  ></lib-section-message-date>
  <app-section-cart
    class="wrap__section wrap__section_section-cart"
    [region]="region"
  ></app-section-cart>
</div>
